import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import rootActions from 'actions/rootActions'
import WIP from 'GeneralUI/WIP/WIP.jsx'

class Billing extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selected: null
    }
  }
  UNSAFE_componentWillMount() {
    // api prep
  }
  shouldComponentUpdate(nextProps, nextState) {
    return this.props.auth !== nextProps.auth || this.state !== nextState
  }
  selectPatient(obj) {
    if (obj.row !== null) {
      this.setState({ selected: obj.row })
    }
  }
  render() {
    return (
      <div className="billing settings">
        <WIP />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    appConfig: state.appConfig,
    auth: state.auth
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(rootActions, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Billing)
